import { render, staticRenderFns } from "./TopicManage.vue?vue&type=template&id=2c009878&scoped=true&"
import script from "./TopicManage.vue?vue&type=script&lang=js&"
export * from "./TopicManage.vue?vue&type=script&lang=js&"
import style0 from "./TopicManage.vue?vue&type=style&index=0&id=2c009878&lang=css&scoped=true&"
import style1 from "./TopicManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c009878",
  null
  
)

export default component.exports